import { Radio as UikitRadio } from '@sgcmpteltd/uikit-react';
import type { ChangeEventHandler } from 'react';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Select: Component = ({
  selectOption,
  name,
  value,
  onChange,
}) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (
    e,
  ) => {
    const option = selectOption.optionList.find(
      opt => opt.value === e.target.value,
    );

    selectOption.onChange?.(
      e.target.value,
    );
    onChange?.({
      name,
      type: 'select',
      optionValue: {
        text: option?.text || '',
        value: option?.value || '',
      },
    });
  };

  return (
    <div className={styles.containerUikitSelect}>
      <UikitRadio
        checked={value.value === (selectOption.placeholder?.value ?? '')}
        label={selectOption.placeholder?.text || 'Any'}
        name={name}
        value={selectOption.placeholder?.value || ''}
        onChange={handleChange} />
      {selectOption.optionList.map(option => (
        <UikitRadio
          key={option.value}
          checked={value.value === option.value}
          label={option.text}
          name={name}
          value={option.value}
          onChange={handleChange} />
      ))}
    </div>
  );
};
